<template>
    <div>
        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item>
                        <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="24" :md="24">
                <el-input v-model="filtro['codigo']" placeholder="Pesquisar por código do exemplar" @keyup.native.enter="loadingExemplares"></el-input>
            </el-col>
            
        </el-row>

        <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" :sm="8" :md="8">
                <el-input v-model="filtro['livro_id']" placeholder="Livro ID" @keyup.native.enter="loadingExemplares"></el-input>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
                <el-select v-model="filtro['status']" placeholder="Status" clearable @change="loadingExemplares" style="width: 100%;">
                    <el-option label="DISPONÍVEL" value="disponivel"></el-option>
                    <el-option label="EMPRESTADO" value="emprestado"></el-option>
                    <el-option label="RESERVADO" value="reservado"></el-option>
                    <el-option label="DANIFICADO" value="danificado"></el-option>
                    <el-option label="PERDIDO" value="perdido"></el-option>
                    <el-option label="DESCARTADO" value="descartado"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                <el-button @click="resetFiltro" plain>LIMPAR FILTROS</el-button>
                <el-button type="primary" @click="abrirCadastro">NOVO EXEMPLAR</el-button>
            </el-col>
            
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                        <th>Código</th>
                        <th class="hidden-mobile">Livro</th>
                        <th class="hidden-mobile u-text-center" style="width: 140px;">Status</th>
                        <th class="hidden-mobile">Localização</th>
                        <th class="hidden-mobile">Conservação</th>
                        <th style="width: 200px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ item.codigo }}</td>
                        <td class="hidden-mobile">{{ (item.livro && item.livro.titulo) ? item.livro.titulo : '-' }}</td>
                        <td class="hidden-mobile u-text-center">{{ (item.status || '').toUpperCase() }}</td>
                        <td class="hidden-mobile u-uppercase">{{ item.localizacao || '-' }}</td>
                        <td class="hidden-mobile u-uppercase">{{ item.estado_conservacao || '-' }}</td>
                        <td class="u-text-center acao">
                            <router-link :to="linkEdit(item.id)" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                            <el-button :disabled="item.status === 'descartado' || item.status === 'emprestado'" @click="abrirDescarte(item)" title="Descartar / dar baixa" type="warning" icon="el-icon-remove-outline" size="mini" plain></el-button>
                            <el-button @click="deleteExemplar(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>

        <el-dialog title="Descartar exemplar" :visible.sync="dialogDescarteVisible" width="450px" :close-on-click-modal="false">
            <el-form @submit.native.prevent="confirmarDescarte" :model="formDescarte" ref="formDescarte" label-position="top">
                <el-form-item label="Data do descarte" prop="data_descarte" :rules="[$requiredChange]">
                    <el-date-picker v-model="formDescarte.data_descarte" type="date" placeholder="Selecionar data" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="Motivo do descarte" prop="motivo_descarte" :rules="[$requiredBlur]">
                    <el-input type="textarea" :rows="3" v-model="formDescarte.motivo_descarte" maxlength="500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item class="u-text-right">
                    <el-button @click="dialogDescarteVisible = false" plain>Cancelar</el-button>
                    <el-button type="warning" id="btn-descartar" native-type="submit">CONFIRMAR DESCARTE</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: {
            codigo: '',
            livro_id: '',
            status: '',
            instituicao_id: '',
            instituicao: { id: '', nome: '' }
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [],
        dialogDescarteVisible: false,
        formDescarte: {
            id: null,
            data_descarte: '',
            motivo_descarte: ''
        }
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted () {
        if(this.$store.state.config.instituicao){
            this.filtro.instituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
        this.loadingExemplares();
    },
    methods: {
        abrirCadastro(){
            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){
                window.eventBus.$emit('alert', {msg: 'Selecione uma instituição antes de cadastrar um exemplar.', type: 'warning'});
                return;
            }
            this.$router.push({
                path: '/admin/biblioteca/exemplar/cadastro',
                query: { instituicao_id: this.$store.state.config.instituicao.id }
            });
        },
        linkEdit(id){
            const inst = this.$store.state.config.instituicao;
            return {
                path: '/admin/biblioteca/exemplar/edit/' + id,
                query: (inst && inst.id) ? { instituicao_id: inst.id } : {}
            };
        },
        async changeInstituicao(){
            if(this.exibeSelectInstituicao){
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }
            this.paginate.page = 1;
            this.loadingExemplares();
        },
        loadingExemplares(){
            this.statusList = false;
            this.items = [];
            this.filtro.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {
                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        deleteExemplar(id){
            this.$msgbox.confirm('Tem certeza que deseja excluir este exemplar?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/delete/` + id, this.$store.getters.getHeaderAuth).then(() => {
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingExemplares();
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }).catch(()=>{});
        },
        abrirDescarte(item){
            this.formDescarte = {
                id: item.id,
                data_descarte: this.$moment().format('YYYY-MM-DD'),
                motivo_descarte: ''
            };
            this.dialogDescarteVisible = true;
        },
        confirmarDescarte(){
            this.$refs.formDescarte.validate((valid) => { if(valid){
                document.getElementById('btn-descartar').focus();
                window.eventBus.$emit('loading', true);
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/descartar/` + this.formDescarte.id,
                    { data_descarte: this.formDescarte.data_descarte, motivo_descarte: this.formDescarte.motivo_descarte },
                    this.$store.getters.getHeaderAuth
                ).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível descartar o exemplar.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Exemplar descartado com sucesso.', type: 'success'});
                    this.dialogDescarteVisible = false;
                    this.loadingExemplares();
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }});
        },
        resetFiltro(){
            this.filtro = {
                codigo: '',
                livro_id: '',
                status: '',
                instituicao_id: '',
                instituicao: this.$store.state.config.instituicao
                    ? { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
                    : { id: '', nome: '' }
            };
            this.paginate.page = 1;
            this.loadingExemplares();
        },
        getPagePagination(page){
            this.paginate.page = page;
            this.loadingExemplares();
        }
    }
}
</script>
